import { filterAssignableStaff } from "../../../services/lookupService";

/** UsersActivity rows eligible for CAPA assignment pickers (IsCRO = 0). */
export function filterCapaAssignableUsers(users = []) {
  return filterAssignableStaff(users);
}

export function mapCapaStaffOptions(users = []) {
  return filterCapaAssignableUsers(users).map((u) => ({
    value: u.StaffId,
    label: u.Name || u.EmailId || String(u.StaffId),
    emailId: u.EmailId || "",
  }));
}
